import { Modal, Button } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import axios from 'axios';

import closeIcon from '../assets/images/cross-close.svg';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ChildQuModalStepTwo } from '../pages/childQuModal/ChildQuModalStepTwo';
import { variables } from "../Variables";

export const ChildQuestionModal = ({ showModal, handleClsoeChildQuestionModal, questions, setupForm,
    setSetupForm }) => {

    const [isQuestionsNotSelected, setIsQuestionsNotSelected] = useState(false);
    const [parentQuestionList, setParentQuestionList] = useState([]);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [triggerType, setTriggerType] = useState("");
    const [triggerValue, setTriggerValue] = useState("");
    const [childQuestionList, setChildQuestionList] = useState([]);
    const [selectChildQu, setSelectChildQu] = useState([]);
    const [isChildQuSelect, setIsChildQuSelect] = useState(false);

    const user = useSelector(state => state.user.user);
    const clientId = user.user.clientId;
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const reduxQuestionDetail = useSelector(state => state.questionDetail.questionDetail);

    useEffect(() => {
        if (questions.length > 0) {
            const filterParentList = questions.filter((parentItem) => {
                const questionDetail = JSON.parse(parentItem.questionDetail);
                //console.log(questionDetail);
                let filterAnsType = questionDetail.answerType == 1 || questionDetail.answerType == 2 || questionDetail.answerType == 3 || questionDetail.answerType == 4;

                return parentItem.parentFieldId == null && parentItem.triggerOperator == null && filterAnsType;
            });
            //console.log(filterParentList);
            setParentQuestionList(filterParentList);
        }
    }, [questions]);

    const onClickQuestionCheckbox = (e, item) => {
        let checked = e.target.checked;
        if (checked) {
            setIsQuestionsNotSelected(false);
            let data = [];
            data.push(item);
            setSelectedQuestions(data);

            const filterRemainingChildQu = questions.filter((parentItem) => {
                return parentItem.parentFieldId == null && parentItem.triggerOperator == null && parentItem.id != item.id;
            });

            setChildQuestionList(filterRemainingChildQu);
        }
    }

    const handlerNextButton = () => {

        // Check if at least one question is selected
        if (selectedQuestions.length === 0) {
            setIsQuestionsNotSelected(true);
            return;
        }

        setIsQuestionsNotSelected(false);
        let next = setupForm + 1;
        setSetupForm(next);
    }

    const handlerPreviousButton = () => {
        if (setupForm === 1) {
            handleClsoeChildQuestionModal();
            handlerClearAllFields();
        } else {

            setSetupForm(setupForm - 1);
        }
    }

    const onChangeTriggerType = (event) => {
        setTriggerType(event);
    }

    const onChangeTriggerValue = (event) => {
        setTriggerValue(event.target.value);
    }

    const onSelectChildQuestion = (event, item) => {
        let checked = event.target.checked;
        if (checked) {
            let data = [];
            data.push(item);
            setSelectChildQu(data);
        }
    }

    const handlerClearAllFields = () => {
        setSelectedQuestions([]);
        setSelectChildQu([]);
        setTriggerType("");
        setTriggerValue("");
    }

    const saveNewChildQuestion = async () => {

        try {
            let url = `${variables.API_URL}Calendar/SaveQuestionCondition`;
            debugger;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.tokenValue}`,
                },
            };

            let getQuestionDetail = JSON.parse(selectedQuestions[0].questionDetail);

            const obj = {
                "clientId": +clientId,
                "childQuestionId": selectChildQu[0].id,
                "parentQuestionId": selectedQuestions[0].id,
                "triggerOperator": getQuestionDetail?.answerType == 4 ? "Gte" : "Equals",
                "triggerValue": triggerValue
            }

            const response = await axios.post(url, obj, config);
            if (response.data) {
                console.log(response.data);
                handleClsoeChildQuestionModal();
                handlerClearAllFields();
            }
        } catch (error) {
            console.log(error);
        }
    }

    const closeModal = () => {
        handlerClearAllFields();
        handleClsoeChildQuestionModal();
    }

    return (
        <Modal show={showModal} onHide={closeModal} className="modalStyle" size="lg">
            <Modal.Body className="p-0">
                <div class="modal-container">
                    <div className="d-flex justify-content-between mb-3">
                        <ul className="form-steps">
                            {
                                setupForm == 1 ?
                                    <>
                                        <li className="step-bar active"></li>
                                        <li className="step-bar"></li>
                                    </>
                                    :
                                    <>
                                        <li className="step-bar"></li>
                                        <li className="step-bar active"></li>
                                    </>
                            }
                        </ul>
                        <img src={closeIcon} onClick={closeModal} className="cursor-pointer" />
                    </div>
                    <div className="">
                        {
                            setupForm == 1 ?
                                <p className="form-title mb-3">Setup Trigger for questions</p>
                                :
                                <>
                                    <p className="form-title mb-2">Setup Trigger for questions</p>
                                    <p className="subtitle mb-4">Preview of parent questions</p>
                                </>
                        }
                    </div>

                    {
                        setupForm === 1 ?
                            <div>
                                {
                                    questions.length > 0 ? 
                                        <Accordion defaultActiveKey="1">
                                            <Accordion.Item eventKey="1" className={`${isQuestionsNotSelected ? "border-red" : ""} mb-0`}>
                                                <Accordion.Header>
                                                    {reduxLanguageTranslations ? reduxLanguageTranslations["bookingFormModalQuestionDropdownSelectQu"] : "Select Questions"}
                                                    {/*<span className="required-icon">*</span> <img src={questionsLoader} width="25" className={`rotating-loader ms-2 ${isQuestionsLoaded == false ? "" : "d-none"}`} />*/}
                                                </Accordion.Header>
                                                <Accordion.Body className="question-accordion-body">
                                                    {
                                                        parentQuestionList.length > 0 ? parentQuestionList.map((item) => {
                                                            let isChecked = false;
                                                            let detail = JSON.parse(item.questionDetail);
                                                            let isFound = selectedQuestions.some(q => q.id == item.id);

                                                            if (isFound == true) {
                                                                isChecked = isFound;
                                                            }
                                                            if (reduxQuestionDetail != null && item.id == reduxQuestionDetail.id) {
                                                                isChecked = true;
                                                            }

                                                            return (
                                                                <label className={`modal-p-text-black question-div d-flex align-items-center mb-2 ${isChecked == true ? "question-bg" : ""}`} key={item.id} htmlFor={`checkbox${item.id}`}>
                                                                    <input className="form-check-input question-check-box me-2" type="checkbox" checked={isChecked} id={`checkbox${item.id}`} onChange={(e) => onClickQuestionCheckbox(e, item)} />
                                                                    {detail[`questionTitle-${reduxSelectedLanguage}`]}
                                                                </label>
                                                            )
                                                        })
                                                            :
                                                            <>
                                                            </>
                                                    }
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                        :
                                        <p>You need two free questions to set up a trigger</p>
                                }
                                
                                {/*<p className="text-red fs-small login-field-error">{requiredFieldMessage}</p>*/}
                            </div>
                            :
                            <ChildQuModalStepTwo
                                selectedQuestions={selectedQuestions} questions={childQuestionList}
                                triggerType={triggerType} triggerValue={triggerValue}
                                onChangeTriggerType={onChangeTriggerType} onChangeTriggerValue={onChangeTriggerValue}
                                onSelectChildQuestion={onSelectChildQuestion} selectChildQu={selectChildQu}
                                isChildQuSelect={isChildQuSelect}
                            />
                    }

                    <div className="d-flex justify-content-center mt-3">
                        <button type="button" className="filter-btn site-btn-padd border-dark color-dark w-25 me-3" onClick={handlerPreviousButton}>{reduxLanguageTranslations ? reduxLanguageTranslations["bookingFormModalBackBtn"] : "Back"}</button>
                        {
                            setupForm == 1 ?
                                <button type="button" className="site-btn site-btn-padd w-25" onClick={handlerNextButton}>{reduxLanguageTranslations ? reduxLanguageTranslations["bookingFormModalNextBtn"] : "Next"}</button>
                                :
                                <button type="button" className="site-btn site-btn-padd w-25" onClick={saveNewChildQuestion}>Save</button>
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}




